'use strict';

export default class upload {
    constructor(options) {
        this.opt = options;
        this.bindHandlers();
    }

    bindHandlers() {
        var self = this;

        /**
         * USER photo
         */
        self.opt.form.on('submit', function (e) {
            e.preventDefault();

            $.ajax({
                url: self.opt.uploadImageRoute,
                type: "POST",
                data: new FormData($(this)[0]),
                contentType: false,
                cache: false,
                enctype: 'multipart/form-data',
                processData: false,
                success: function (data) {
                    if (data.success) {
                        $('img.cvPhoto').attr('src', data.newImage).removeClass('hidden-photo');
                        $('.employee-img .no-image-block').addClass('hidden');
                        $('.cell.shrink .update-image-buttons').show();
                        $('.cell.shrink .uploaded-cv-image').show();
                        $('.cell.shrink label.upload-image-label').hide();
                        $('form[name=cv_photo]')[0].reset();
                    } else {
                        alert(data.message);
                    }
                },
                error: function () {
                    console.log('error');
                }
            });

            return false;
        });

        // upload and delete USER photo
        self.opt.form.on('change', 'input.uploadNewCvPhoto', function () {
            $(this.form).submit();
            return false;
        });

        self.opt.form.on('click', '.delete-cv-photo', function () {
            $.ajax({
                url: self.opt.deleteImageRoute,
                type: "POST",
                async: false,
                data: {delete: 'image'},
                contentType: false,
                cache: false,
                processData: false,
                success: function (data) {
                    if (data.success) {
                        $('.cell.shrink .update-image-buttons').hide();
                        $('.cell.shrink .uploaded-cv-image').hide();
                        $('.cell.shrink label.upload-image-label').show();
                    } else {
                        alert(data.message);
                    }
                },
                error: function (e) {
                    console.log('error');
                }
            });
        });
    }
}